import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { showSuccessModal } from 'src/services/dialogs'

import {
  MEASUREMENT_RULES_MANAGMENT_UPDATE_MESSAGE,
  MEASUREMENT_SETTINGS_GET,
  MEASUREMENT_SETTINGS_GET_PATCH_DELETE,
  MEASUREMENT_SETTINGS_POST
} from './constants'

export const getMeasurementRule = async (config: any = {}) => {
  const { query = {}, params = {} } = config

  try {
    const response = await httpClient.request({
      method: 'get',
      url: {
        pathname: MEASUREMENT_SETTINGS_GET,
        params,
        query
      }
    })

    return response
  } catch (err: any) {
    catchError(err)

    return {}
  }
}

export const getMeasurementRuleByUuid = async (config: any = {}) => {
  const { query = {}, params = {} } = config

  try {
    const response = await httpClient.request({
      method: 'get',
      url: {
        pathname: MEASUREMENT_SETTINGS_GET_PATCH_DELETE,
        params,
        query
      }
    })

    return response
  } catch (err: any) {
    catchError(err)

    return {}
  }
}

export const saveMeasurementRule = async (config: any = {}) => {
  const { payload = {}, params = {} } = config

  try {
    await httpClient.request({
      method: 'post',
      url: {
        pathname: MEASUREMENT_SETTINGS_POST,
        params
      },
      payload
    })

    return true
  } catch (err: any) {
    catchError(err)

    return false
  }
}

export const updateMeasurementRule = async (config: any = {}) => {
  const { payload = {}, params = {} } = config

  try {
    await httpClient.request({
      method: 'patch',
      url: {
        pathname: MEASUREMENT_SETTINGS_GET_PATCH_DELETE,
        params
      },
      payload
    })

    showSuccessModal({
      content: MEASUREMENT_RULES_MANAGMENT_UPDATE_MESSAGE,
      centered: true,
      keyboard: false
    })

    return true
  } catch (err: any) {
    catchError(err)

    return false
  }
}

export const deleteMeasurementRule = async (config: any = {}) => {
  const { params = {} } = config

  try {
    await httpClient.request({
      method: 'delete',
      url: {
        pathname: MEASUREMENT_SETTINGS_GET_PATCH_DELETE,
        params
      }
    })

    return true
  } catch (err: any) {
    catchError(err)

    return false
  }
}
